<div class="header-label-container" id="TableHeaderContainer_{{ columnDef.colId }}">
    <div class="process-header ag-header-cell-text">Process</div>
    <div class="summary-header ag-header-cell-text">Summary</div>
</div>
